import { render, staticRenderFns } from "./TaskStatementBreakdown.vue?vue&type=template&id=7dc86d54&scoped=true"
import script from "./TaskStatementBreakdown.vue?vue&type=script&lang=js"
export * from "./TaskStatementBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc86d54",
  null
  
)

export default component.exports